// MV バッジ（以前の MV アイコンと同じ tada）
$(window).on('load', function () {
  var target = $('.mv__badge');
  if (!target.length) return;

  function playTada() {
    target.removeClass('is-tada');
    void target[0].offsetWidth;
    target.addClass('is-tada');
  }

  playTada();
  setInterval(playTada, 2000);
});

// プルダウン
if (window.matchMedia('(max-width: 767px)').matches) {
  $('.js-judge-sp').on('click', function (event) {
    event.preventDefault();
    $(this).toggleClass('is_open');
    $(this).children().slideToggle();
  });
}
